import {FDS_SUCCESS_SUB_PATH} from './constants'

/**
 * 결제창 ROUTES
 */
const PAYMENT_APP_PATH = '/instantPay' as const

const PAYMENTS_APP_PATH = '/payments' as const

const PAYMENT_SERVICE = {
    // 인증형 단건
    PARTNERS_PAYMENT: 'partners',
    // 인증형 자동
    PARTNERS_AUTO: 'partnersAuto',
    // 결제형 단건
    NAVER_FINANCIAL_PAYMENT: 'nfPayment',
    // 결제형 자동
    NAVER_FINANCIAL_AUTO: 'nfAuto',
} as const

export const PAYMENT_ROUTES = {
    /** 결제형 단건 주문서 */
    NAVER_FINANCIAL_PAYMENT: {
        MAIN: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_PAYMENT}`,
        CHECKOUT: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_PAYMENT}`,
        APPLY: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_PAYMENT}/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 결제형 자동 주문서 */
    NAVER_FINANCIAL_AUTO: {
        MAIN: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_AUTO}`,
        CHECKOUT: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_AUTO}`,
        APPLY: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.NAVER_FINANCIAL_AUTO}/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 인증형 단건 주문서 */
    PARTNERS_PAYMENT: {
        MAIN: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS_PAYMENT}`,
        CHECKOUT: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS_PAYMENT}/checkout`,
        APPLY: `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS_PAYMENT}/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 인증형 정기 주문서
     * `${PAYMENT_APP_PATH}/${PAYMENT_SERVICE.PARTNERS_AUTO}` 로 변경 예정
     * */
    PARTNERS_AUTO: {
        MAIN: `/paymentMethods/partners`,
        CHECKOUT: `/paymentMethods/partners/checkout`,
        APPLY: `/paymentMethods/partners/${FDS_SUCCESS_SUB_PATH}`,
    },
    /** 결제 상세 */
    DETAIL: {
        MAIN: `${PAYMENT_APP_PATH}/detail`,
    },
    /** 포인트 받기 페이지 */
    RECEIVE_POINT: {
        MAIN: `${PAYMENT_APP_PATH}/receivePoint`,
    },
    /** 청구서 관리 페이지 */
    INVOICE: {
        MAIN: `${PAYMENTS_APP_PATH}/invoice`,
    },
} as const
